import anime from 'animejs';

export default class AgendaSchedule {
  constructor(el) {
    this.el = el;
    this.trigger = this.el.querySelector('[data-toggle]');
    this.hidden = this.el.querySelector('[data-hidden]')
    this.icon = this.el.querySelector('[data-icon]')
    this.isOpen = false;

    this.bind();
  }

  bind() {
    this.trigger.addEventListener('click', this.toggle.bind(this));
  }

  toggle() {
    if (this.isOpen) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this.icon.innerText = '-';
    this.hidden.classList.add('visible')

    // Deactivate animation
    // const contentHeight = this.hidden.querySelector('.u-agenda-schedule-item__toggle__content').offsetHeight;
    // anime({
    //   targets: this.hidden,
    //   duration: 300,
    //   height: contentHeight,
    //   easing: 'easeInSine',
    // });

    this.isOpen = true;
  }

  close() {
    this.icon.innerText = '+';
    this.hidden.classList.remove('visible')

    // Deactivate animation
    // anime({
    //   targets: this.hidden,
    //   duration: 300,
    //   height: '0',
    //   easing: 'easeInSine',
    // });

    this.isOpen = false;
  }
}
